import ExitToApp from '@mui/icons-material/ExitToApp';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    List,
    ListItemButton,
    ListItemText,
    Tooltip,
    Typography
} from '@mui/material';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from './ReactComponent';

class PainelUsuarioLogado extends ReactComponent {
    modalSelecionarOJC = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            modalSelecionarOJC: observable,
            handleClickOrgaoJulgador: action,
            orgaosJulgadoresColegiadosUsuario: computed,
            exibirBotaoSair: computed,
            tooltipDescricaoLocalizacao: computed,
            exibeModalOJC: computed,
            handleCloseModal: action,
            localizacaoUsuario: computed,
            nomeUsuario: computed
        });
    }

    handleClickSair = () => {
        this.appStore.fecharApp();
        this.routerStore.push('/');
    };

    handleClickOrgaoJulgador = async (orgaoJulgadorColegiado) => {
        this.modalSelecionarOJC = false;
        this.usuarioStore.configurarLocalizacao(orgaoJulgadorColegiado);
        this.sessaoStore.reset();
        this.salaSessaoStore.reset();
        await this.sessaoStore.inicializar();
        this.sessaoStore.inicializarSessaoJulgamento();
        if (this.routerStore.isPautaJulgamento) {
            this.pautaJulgamentoStore.reset();
            this.pautaJulgamentoStore.inicializarPautaJulgamento();
        }
    };

    get orgaosJulgadoresColegiadosUsuario() {
        return this.usuarioStore.usuario.orgaosJulgadoresColegiados || [];
    }

    get exibirBotaoSair() {
        return this.usuarioStore?.isUsuarioLogado && this.routerStore?.location.pathname !== '/';
    }

    get tooltipDescricaoLocalizacao() {
        return (
            <>
                <Typography>{this.usuarioStore.usuario.descricaoLocalizacao}</Typography>
                {this.exibeModalOJC && <Typography>(Selecionar outro órgão julgador)</Typography>}
            </>
        );
    }

    get exibeModalOJC() {
        return (
            this.usuarioStore.usuario.orgaosJulgadoresColegiados &&
            this.usuarioStore.usuario.orgaosJulgadoresColegiados.length > 1
        );
    }

    handleCloseModal = () => {
        this.modalSelecionarOJC = false;
    };

    get localizacaoUsuario() {
        return this.usuarioStore.usuario.localizacao;
    }

    get nomeUsuario() {
        return this.usuarioStore.usuario.nome
            ? this.usuarioStore.usuario.nome.toUpperCase()
            : this.usuarioStore.usuario.cpf;
    }

    render() {
        if (!this.exibirBotaoSair) {
            return null;
        }

        return (
            <>
                <Tooltip title={this.nomeUsuario}>
                    <Typography
                        component="h5"
                        style={{
                            fontSize: '1em',
                            fontWeight: 'normal',
                            margin: '0px 5px',
                            maxWidth: '500px',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}
                        color="inherit"
                    >
                        {this.nomeUsuario}
                    </Typography>
                </Tooltip>
                {this.routerStore.location.pathname !== '/acompanhamento-sessao' && (
                    <>
                        <Tooltip title={this.tooltipDescricaoLocalizacao}>
                            <Box
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    boxSizing: 'border-box',
                                    borderColor: 'white',
                                    borderStyle: 'solid',
                                    borderWidth: '1px',
                                    borderRadius: '4px',
                                    cursor: this.exibeModalOJC ? 'pointer' : 'inherit',
                                    paddingLeft: '5px',
                                    paddingRight: '4px',
                                    marginLeft: '5px',
                                    height: '30px'
                                }}
                                onClick={
                                    this.exibeModalOJC
                                        ? () => runInAction(() => (this.modalSelecionarOJC = true))
                                        : undefined
                                }
                            >
                                <Typography
                                    component="h5"
                                    style={{
                                        fontSize: '1em',
                                        fontWeight: 'normal',
                                        whiteSpace: 'nowrap',
                                        marginRight: '7px',
                                        marginLeft: '5px',
                                        paddingTop: '1px'
                                    }}
                                    color="inherit"
                                >
                                    {this.localizacaoUsuario}
                                </Typography>
                                {this.exibeModalOJC && <KeyboardArrowDown style={{ fill: 'white' }} />}
                            </Box>
                        </Tooltip>
                        <IconButton
                            onClick={this.handleClickSair}
                            color="inherit"
                            style={{
                                width: '40px',
                                marginLeft: '5px',
                                display: this.routerStore.location.pathname !== '/acompanhamento-sessao' ? '' : 'none'
                            }}
                            size="large"
                        >
                            <Tooltip title={'Sair'}>
                                <ExitToApp />
                            </Tooltip>
                        </IconButton>
                    </>
                )}
                {this.modalSelecionarOJC && (
                    <Dialog
                        open={this.modalSelecionarOJC}
                        onClose={this.handleCloseModal}
                    >
                        <DialogTitle>Selecionar órgão julgador</DialogTitle>
                        <DialogContent>
                            <List
                                component="nav"
                                style={{ padding: '0px 10px 10px 10px' }}
                            >
                                {this.orgaosJulgadoresColegiadosUsuario.map((ojc) => (
                                    <ListItemButton
                                        key={ojc.sigla}
                                        onClick={() => this.handleClickOrgaoJulgador(ojc)}
                                    >
                                        <ListItemText primary={ojc.descricao} />
                                    </ListItemButton>
                                ))}
                            </List>
                        </DialogContent>
                    </Dialog>
                )}
            </>
        );
    }
}

export default inject('stores')(observer(PainelUsuarioLogado));
